import { JobStatus } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const JobStatusService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobStatuses: JobStatus[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobStatuses = async (useCache: boolean = true): Promise<JobStatus[]> => {
    if (useCache && cachedJobStatuses != null)
      return cachedJobStatuses;

    if (dotNetObj) {
      cachedJobStatuses = await dotNetObj.invokeMethodAsync<JobStatus[]>('GetAsync');
      return cachedJobStatuses;
    } else {
      throw 'Job Status DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobStatuses,
  };
})();
